export const Constant = {
  MIN_OPACITY: 0,
  MAX_OPACITY: 1,

  MIN_SCALE: 0,
  MAX_SCALE: 1,

  INITIAL_TRANSLATE_X: 0,
  MAX_TRANSLATE_X: 200,

  DEFAULT_DURATION_IN_MS: 250,
  DEFAULT_DELAY_IN_MS: 0,
};
